import { Route, Routes } from 'react-router-dom';

import { CsPage } from '@/app/cs/page';
import { FairyTalesPage } from '@/app/fairy-tales/page';
import { HomePage } from '@/app/home/page';
import { IntroPage } from '@/app/intro/page';
import { LoginPage } from '@/app/login/page';
import { MoviesPage } from '@/app/movies/page';
import { NurseryRhymesPage } from '@/app/nursery-rhymes/page';
import { ProfilePage } from '@/app/profile/page';
import { SplashPage } from '@/app/splash/page';
import { TermsPage } from '@/app/terms/page';
import { TopicDetailPage } from '@/app/topics/[id]/page';
import { TopicsPage } from '@/app/topics/page';
import { VideoPage } from '@/app/videos/page';

export const AppRouter = () => (
  <Routes>
    <Route path="/" element={<IntroPage />} />
    <Route path="/splash" element={<SplashPage />} />
    <Route path="/login" element={<LoginPage />} />

    <Route path="/home" element={<HomePage />} />
    <Route path="/nursery-rhymes" element={<NurseryRhymesPage />} />
    <Route path="/fairy-tales" element={<FairyTalesPage />} />
    <Route path="/movies" element={<MoviesPage />} />
    <Route path="/topics" element={<TopicsPage />} />
    <Route path="/topics/:id" element={<TopicDetailPage />} />

    <Route path="/videos" element={<VideoPage />} />

    <Route path="/profile" element={<ProfilePage />} />
    <Route path="/terms" element={<TermsPage />} />
    <Route path="/cs" element={<CsPage />} />
  </Routes>
);
